<template>
  <div class="m-confirm">
    <div class="back">返回</div>
  </div>
</template>

<script>
/**
 *   disabled   <m-button :disabled="!nextState" @click.native="toNext()">下一步</m-button>
 */
export default {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>

</style>
